import { render, staticRenderFns } from "./NotificationWebTrigger.vue?vue&type=template&id=1e71b187&scoped=true&"
import script from "./NotificationWebTrigger.vue?vue&type=script&lang=js&"
export * from "./NotificationWebTrigger.vue?vue&type=script&lang=js&"
import style0 from "./NotificationWebTrigger.vue?vue&type=style&index=0&id=1e71b187&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71b187",
  null
  
)

export default component.exports